$.loginToolbar = function() {

'use strict';

	function showLoginFormClicked(event) {
		var $clickedLoginElem = $(this);
		event.preventDefault();
		
		return $.showLoginForm($clickedLoginElem);
	}

	/**
	 * Click handler for the login elements.
	 * Create and show the login form
	 * @param {Event} event
	 * @returns {Boolean}
	 */
	$.showLoginForm = function($clickedLoginElem) {
		
		var $form = $('<form id="loginfrm" style="z-index: 50000;" method="post" action="#">' +
			'<div id="loginmsg" style="display:none"></div>'+	
			'<div id="elems">'+	
			'<div id="loginfields">' +
			'<label for="lname">' + $.i81n.text('NAMEORMAIL') + '</label><br />'+
			'<input type="text" id="lname" name="lname" required style="width:100%" size="25" maxlength="200" /><br />'+
			'<label for="password">' + $.i81n.text('PASSWORD') + '</label><br />'+
			'<input type="password" id="password" name="password" required style="width:100%" size="32" maxlength="32" /><br />'+
			'<input accesskey="B" type="checkbox" id="autologin" name="autologin" value="1" /> <label for="autologin">' + $.i81n.text('AUTOLOGIN') + '</label><br />'+
			'</div>'+
			'<input accesskey="M" id="loginbtn" type="submit" value=" ' + $.i81n.text('LOGIN') + ' " />'+
			'<input id="cancelbtn" type="button" value=" ' + $.i81n.text('CANCEL') + ' " /><br />'+
			($('#loginimg').hasClass('nopwreset') ? '' : '<a id="forgotpass" href="/forgotpass.php">' + $.i81n.text('FORGOTTPASS') + '</a>')+
			'</div>'+
			'<div id="logininfo"></div>'+
			'</form>');
		
		/**
		 * Returns the markup for the hidden initkey element
		 * @param {String} initID
		 * @returns {String}
		 */
		function getInitKeyMarkup(initID) {
			return '<input name="initkey" id="initkey" type="hidden" value="' + initID + '">';
		}

		/**
		 * Build and return the security questions/answer markup to inititalize
		 * the security questions
		 * @param {type} questionConf
		 * @returns {undefined}
		 */
		function getSecurityQAmarkup(questionConf) {
			var cnt = 0;
			var questCnt = 0;
			var questionMarkup = '';
			var questionLength = $.map(questionConf.questions, function(val, idx) { 
				return [val];
			}).length;
			var useQuestions = Math.min(questionConf.init.selectboxCount, questionLength / 2);
			var questionsPerSelect = (questionLength / useQuestions);
			var answerInputTpl = '<input type="text" name="seca%CNT%" id="seca%CNT%" maxlength="50" required pattern=".{3,}" title="' + 
					questionConf.init.inputHint + '" placeholder="' + questionConf.init.inputHint + '" style="min-width:100%;"><br>';
			var selectTpl = '<label for="secq%CNT%">' + questionConf.init.selectboxLabel+ ' %CNT%</label><br>' +
						'<select name="secq%CNT%" id="secq%CNT%" value="0" required style="min-width:100%;">' +
						'<option value="" style="display:none;" selected>' + questionConf.init.selectboxHint + '</option>';
			var optionTpl = '<option value="%ID%">%QUEST%</option>';
			var dateSuffix = '_' + new Date().getTime();

			$.each(questionConf.questions, function(qid, question) {
				if (cnt === 0 || (cnt % questionsPerSelect) === 0) {
					questionMarkup += (questCnt > 0 
							? '</select><br>' + answerInputTpl.replace(/\%CNT\%/g, questCnt + dateSuffix)
							: '');

					++questCnt;
					questionMarkup += selectTpl.replace(/\%CNT\%/g, questCnt);
				}
				questionMarkup += optionTpl.replace(/\%ID\%/g, qid).replace(/\%QUEST\%/g, question);
				++cnt;
			});

			questionMarkup += (questCnt > 0 
					? '</select><br>' + answerInputTpl.replace(/\%CNT\%/g, questCnt + dateSuffix)
					: '');


			return getInitKeyMarkup(questionConf.init.initID) + questionMarkup;
		}

		/**
		 * Build and return the markup for the security questions which needs an answer
		 * @param {type} questionConf
		 * @returns {undefined}
		 */
		function getSecurityQuestionMarkup(questionConf) {
			var questCnt = 0;
			var questionMarkup = '';
			var answerInputTpl = '<label for="seca%CNT%">%QUEST%</label><br>' +
							'<input type="text" name="seca%CNT%" id="seca%CNT%" maxlength="50" required pattern=".{3,}" title="' + 
					questionConf.init.answerHint + '" placeholder="' + questionConf.init.answerHint + '" style="min-width:100%;"><br>';
			var dateSuffix = '_' + new Date().getTime();

			$.each(questionConf.questions, function(qid, question) {
				questionMarkup += answerInputTpl.replace(/\%CNT\%/g, (++questCnt) + dateSuffix)
									.replace(/\%QUEST\%/g, question);
			});

			return questionMarkup;
		}

		/**
		 * Build a random name for the otp input to disable the autocomplete feature. 
		 * Reflect changes to input[name='otp'] 
		 */
		function initializeOtpInputs() {
			$('#otpfields').append('<label for="otp">' + $.i81n.text('OTPCODE') + 
				'</label><br><input type="number" min="1" max="999999" id="otp" class="no-spinners" required style="width:100%;" placeholder="' + $.i81n.text('OTP_INPUTFORMAT') + '">' +
				'<input type="hidden" name="otp">');

			$('#otp').on('input', function() {
				$('input[name="otp"]').val($('#otp').val());
			});
		}
		
		/**
		 * Scroll the body if needed to show the full form
		 * @returns {undefined}
		 */
		function ensureVisible() {
			if ($showFormElem) {
				// ensure the for is comlplete visible
				var formPos = { 
					formTop: Math.floor($form.offset().top), 
					formHeight: $form.outerHeight(),
					bodyHeight: $('body').height()
				};

				if ((formPos.bodyHeight + $(window).scrollTop()) < (formPos.formTop + formPos.formHeight)) {
					$(window).scrollTop(formPos.formTop + formPos.formHeight - formPos.bodyHeight);
				}
			}
		}
		
		//////////////////////////////////////////////////
		//Generate the form
		//////////////////////////////////////////////////
		
		// check if the cookie info is avaiable and confirmed
		if ($('#cookieinfo').length > 0 &&
				$.cookieHelper.getCookie('cc') !== '1') {
			$.showMessiDlgToConfirm('', $.i81n.text('INFO_CHECKCOOKIE'), 'anim error');
			return false;
		}
		
		var $pagehead = $('#pagehead');
		
		if (!loginCreated) {
			// check if there are login elements in the page
			if ($('#lname').length > 0) {
				$.showMessiDlgToConfirm($.i81n.text('LOGIN'), $.i81n.text('INFO_USE_ONPAGE_LOGIN'), 'anim error', {
					callback: function() {
						$('#lname').focus();
					}
				});
				return false;
			}
					
			var currentUrl = escape(window.location.href.toString().split(window.location.host)[1]);

			if (typeof $clickedLoginElem !== 'undefined' && $clickedLoginElem.hasClass('userloginlink')) {
				$form.css({
					position: 'static',
					'margin-top': '15px'
				});
				// replace the element or the .userlogincontainer parent element
				// with the created login form
				var $clickedParent = $clickedLoginElem.closest('.userlogincontainer');
				$showFormElem = ($clickedParent.length > 0 ? $clickedParent : $clickedLoginElem).replaceWith($form);
			} else {
				if($pagehead.css('position') === 'fixed'){
					$pagehead.css('position', 'absolute');
					$pagehead.attr('data-resetCss', 'true');
				}

				var $formParent = $('#loginimg').closest('nav');
				if ($formParent.is(':visible')) {
					$formParent.append($form);
				} else {
					$('body').prepend($form);
				}
				
				//if($(window).width() < 400) {// <= $('#pagehead').width()){
				var posLeft = $('#loginimg').parent().offset().left;
				if (posLeft < 100) {
					$('#loginfrm').css('left', 10);
				}else{
					$('#loginfrm').css('left', Math.min($('#loginimg').closest('nav').width()-$form.outerWidth(), posLeft));
				}
			}

			// trigger password input toggle generation
			$(document).trigger('moreJS:addPwSwitch');

			$('#loginfrm:hidden').slideDown(function() {
				loginCreated = true;

				ensureVisible();
				
				$('#lname').focus();
				$('#loginimg').closest('li').addClass('active');
			});


			// get login information
			$.post('/login.php', 
					'info=1&url=' + currentUrl, 
					function(infoMsg) {
				if (infoMsg) {
					$('#logininfo').html(infoMsg);
				} else {
					$('#logininfo').remove();
				}
			});

			// cancel click handler
			$('#cancelbtn').on('click', function() {
				var $replaceElem = $showFormElem;
				$showFormElem = null;
				
				$('#loginfrm').slideUp(400, function() {
					if ($replaceElem) {
						$('#loginfrm').replaceWith($replaceElem);
						$('.userloginlink').off('click.login').on('click.login', showLoginFormClicked);
					} else {
						$('#loginfrm').remove();
						
						if($pagehead.attr('data-resetCss')){
							$pagehead.attr('data-resetCss', false);
							$pagehead.css('position', 'fixed');
						}
					}
				});
				$('#loginimg').closest('li').removeClass('active');
				ajaxUrl = '/login.php';
				loginCreated=false;
				
				return false;
			});

			// login click handler
			$('#loginfrm').on('submit', function() {
				var msgStyle = {'display': 'inline-block', 'padding':'10px', 'line-height':'120%'};
				$.ajax({
					type: 'POST',
					url: ajaxUrl,
					data: $('#loginfrm').serialize() + '&url=' + currentUrl,
					success: function(status) {
						if (status.substr(0,2) === 'ok') {
							if (status.substr(3) === 'no-ws') {
								$('#loginmsg').html($.i81n.text('LOGGEDIN_NOCMS')).css(msgStyle);
								status = 'ok';
							} else {
								$('#loginmsg').html($.i81n.text('LOGGEDIN')).css(msgStyle);
							}
							setTimeout(function(){
									var loc = location.href.toString();
									if (status.length > 2) {
										// the result is 'ok:redirect_to_location'
										window.location.href = status.substr(3);
									} else {
										var idx = loc.indexOf('newpass.php');
										if (idx > -1) {
											location.href = loc.substr(0, idx);
										} else  {
											// don't use location.reload()! Because this sends possible existing form input data again
											idx = loc.indexOf('#');
											if (idx > -1) {
												loc = loc.substring(0, idx);
											}
											location.href = loc;
										}
									}
							}, 1800);
						}
						else if (status === 'needOTP') {
							$('#loginmsg').css(msgStyle);
							$('#loginmsg').html($.i81n.text('INPUT_OTPCODE'));
							$('#loginfields, #forgottpass').hide();
							$('#elems, #logininfo').show();
							$('#otpfields').remove();
							$('<div id="otpfields"><br></div>').insertBefore('#loginbtn');
							if ($('#getsecq').length === 0) {
								$('#elems').append('<a id="getsecq" href="javascript:;">' + $.i81n.text('AUTHAPP_UNAVAILABLE') + '</a>');
							}
							$('#getsecq').on('click', function() {
								$(this).replaceWith('<input type="hidden" id="getsecq" name="getsecq" value="1">');
								$('#otpfields').remove();
								$('#loginfrm').trigger('submit');
								return false;
							});
							initializeOtpInputs();
							$('#forgotpass').remove();
							$('#elems, #logininfo').show();
							$('#autologin').val('0').hide();

							ensureVisible();
							$('#otp').focus();
						}
						else if (status.substr(0, 17) === 'confirmOTPsecret:') {
							var secretConf = JSON.parse(status.substr(17));
							// change ajax url 
							ajaxUrl = '/login.php?secinit=2';
							$('#loginmsg').css(msgStyle);
							$('#loginmsg').html(secretConf.formHeader);
							var $initKey  = $('#initkey').detach();
							$('#questions').hide();
							$('#loginfields').hide();
							$('#elems, #logininfo').show();
							
							$('<div id="secretinit" style="width:100%;"><div style="text-align:center;">' + secretConf.imgMarkup + 
									'</div><div id="otpfields"></div>').insertBefore('#loginbtn');
							$initKey.insertBefore('#loginbtn');
							initializeOtpInputs();
							if ($('#initkey').length > 0 &&
									secretConf.initID !== $('#initkey').val()) {
								$('#cancelbtn').trigger('click');
							} else {
								$(getInitKeyMarkup(secretConf.initID)).insertBefore('#loginbtn');
							}
							$('#resetsec').hide();
							$('#cancelbtn').on('click', function() {
								location.reload();
							});
							$('#resetotp').prop('checked', false);

							ensureVisible();
							$('#otp').focus();
						}
						else if (status.substr(0, 17) === 'needSecurityInit:') {
							var questionConf = JSON.parse(status.substr(17));
							// change ajax url 
							ajaxUrl = '/login.php?secinit=1';
							$('#loginmsg').css(msgStyle);
							$('#loginmsg').html(questionConf.init.initQuestions);
							$('#loginfields, #forgottpass').hide();
							$('#elems, #logininfo').show();
							$('#autologin').val('0');
							$('#forgotpass').remove();
							$('<div id="questions">' + getSecurityQAmarkup(questionConf) + '</div>')
									.insertBefore('#loginbtn');

							ensureVisible();
							$('#secq1').focus();
						}
						else if (status.substr(0, 15) === 'needSecurityQA:') {
							var questionConf = JSON.parse(status.substr(15));
							// change ajax url 
							ajaxUrl = '/login.php';
							$('#loginmsg').css(msgStyle);
							$('#loginmsg').html(($('#questions').length !== 0 
													? '<span style="color:red">' + questionConf.init.answerError + '</span><br>' 
													: '') +
									questionConf.init.answerQuestions);
							$('#loginfields, #forgottpass').hide();
							$('#elems, #logininfo').show();
							$('#autologin').val('0');
							$('#forgotpass').remove();
							if ($('#questions').length === 0) {
								$('<div id="questions">' + getSecurityQuestionMarkup(questionConf) + '</div>')
										.insertBefore('#loginbtn');
							}
							// set the received initkey
							$('#initkey').val(questionConf.init.initID);
							// add checkbox to request reset the otp secret
							if ($('#getsecq').length > 0 && $('#resetsec').length === 0) {
								$('<div id="resetsec"><input accesskey="X" type="checkbox" id="resetotp" name="resetotp"> <label for="resetotp">' + $.i81n.text('OTP_RESET') + '</label><br></div>')
										.insertBefore('#loginbtn');
							}

							ensureVisible();
							$('input[id^="seca1_"').focus();
						}
						else {
							$('#loginmsg').css(msgStyle);

							if (status.substring(0, 8) === 'nologin:') {
								$('#loginmsg').html('<span style="color:red">' + status.substring(8) + '</span>');
								$('#loginbtn').hide();
							} else {
								$('#loginmsg').html('<span style="color:red">' + status + '</span>');
							}

							$('#elems, #logininfo').show();
							$('#otp').val('');
						}
					},
					beforeSend: function() {
						$('#elems, #logininfo').hide();
						$('#loginmsg').html($.i81n.text('DOLOGIN')).css(msgStyle);
					},
					error: function( jqXHR, textStatus, errorThrown ) {
						$('#loginmsg').html(textStatus + ': ' + errorThrown).css(msgStyle);
						$('#elems, #logininfo').show();
					}
				});
				return false;
			});
		} else {
			$('#cancelbtn').click();
		}

	}; // showLoginFormClicked()

	/**
	 * Define the document click handler to remove the menu	when visible
	 */
	$(document).on('click.loginclose', function(e) {
		// handle only when the click target is not a child of the form
		if (loginCreated && $(e.target).closest('#loginfrm').length === 0 &&
				!$showFormElem) {
			$('#cancelbtn').click();
		}
	});

	/**
	 * Define window key handlers to show the login form if ctrl+A was 
	 * pressed two times within two seconds and
	 * Escape key handler to close the login form if visible
	 */
	$(window).on('keydown.login', function(event) {
		// show login dialog when ctrl+A was pressed 2 times
		if (event.which === 65 && event.ctrlKey) {
			event.preventDefault();
			if ((Date.now() - login1stKeyTime) < 2000) {
				event.stopImmediatePropagation();
				event.preventDefault();
				login1stKeyTime = 0;
				$('#loginimg ').trigger('click');
				return false;
			} else {
				login1stKeyTime = Date.now();
			}			
		} else if (event.which === 27 && // esc handler for visible login form
				!event.ctrlKey && !event.shiftKey && !event.altKey && !event.metaKey &&
				$('#loginfrm').length > 0 && $('#loginfrm').is(':visible')) {
			
			event.preventDefault();
			$('#cancelbtn').trigger('click');
		}
	});

	/**
	 * status if login form was created
	 * @type Boolean
	 */
	var loginCreated=false;
	
	/**
	 * Stored the time when the key Ctrl+A was pressed
	 * @type Number|@exp;Date@call;now
	 */
	var login1stKeyTime = 0;


	/**
	 * The url to use for the next ajax call
	 * @type String
	 */
	var ajaxUrl = '/login.php';


	/**
	 * The old element replaced with the from
	 * @type $clickedParent|$clickedLoginElem
	 */
	var $showFormElem = null;

	/**
	 * define the click handler for login form
	 */
	var $loginElems = $('#loginimg, #ws-webshopfunctions .ws-account, #showlogin').closest('a');
	$('.userlogincontainer, .userloginlink').show();
	$loginElems = $loginElems.add($('.userloginlink'));	
	$loginElems.on('click.login', showLoginFormClicked); 

	/**
	 * check to show the login dialogue
	 */
	if ($('.triggerlogin').length > 0) {
		setTimeout(function() {
			$('#loginimg').closest('a').trigger('click');
		}, 1000);
	}

};
